import React from 'react';

const RandomizerBackgroundSpawner = ({ state, callbacks }) => {
  const settings = state.randomizerSettings.backgroundSpawner;

  return (
    <div className="w-full bg-transparent p-0 space-y-4">
      <p className="text-sm text-dark-text-muted leading-relaxed">
        Spawnt Cubes unterschiedlicher Größe mit zufälligen Texturen im Hintergrund. Diese füllen den Großteil des Hintergrunds.
      </p>

      {state.randomizers.backgroundSpawner && (
        <>
          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Anzahl der Cubes</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.minObjects}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      minObjects: parseInt(e.target.value) || 1
                    }
                  })}
                  min="1"
                  step="1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.maxObjects}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      maxObjects: parseInt(e.target.value) || 1
                    }
                  })}
                  min="1"
                  step="1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Größenbereich</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.minSize}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      minSize: parseFloat(e.target.value) || 0.1
                    }
                  })}
                  min="0.1"
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.maxSize}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      maxSize: parseFloat(e.target.value) || 1.0
                    }
                  })}
                  min="0.1"
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Position X-Bereich</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.positionRange.minX}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      positionRange: { ...settings.positionRange, minX: parseFloat(e.target.value) || 0 }
                    }
                  })}
                  step="0.5"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.positionRange.maxX}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      positionRange: { ...settings.positionRange, maxX: parseFloat(e.target.value) || 0 }
                    }
                  })}
                  step="0.5"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Position Y-Bereich</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.positionRange.minY}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      positionRange: { ...settings.positionRange, minY: parseFloat(e.target.value) || 0 }
                    }
                  })}
                  step="0.5"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.positionRange.maxY}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      positionRange: { ...settings.positionRange, maxY: parseFloat(e.target.value) || 0 }
                    }
                  })}
                  step="0.5"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Position Z-Bereich</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.positionRange.minZ}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      positionRange: { ...settings.positionRange, minZ: parseFloat(e.target.value) || 0 }
                    }
                  })}
                  step="0.5"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={settings.positionRange.maxZ}
                  onChange={(e) => callbacks.setRandomizerSettings({
                    ...state.randomizerSettings,
                    backgroundSpawner: {
                      ...settings,
                      positionRange: { ...settings.positionRange, maxZ: parseFloat(e.target.value) || 0 }
                    }
                  })}
                  step="0.5"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
            <p className="text-xs text-dark-text-muted mt-2 leading-relaxed">
              Negative Z-Werte platzieren Cubes hinter dem Hauptobjekt
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default RandomizerBackgroundSpawner;
